import React, { useState } from "react";

import TopTitle from "../components/TopTitle";
import FaqItem from "../components/faq/FaqItem.js";
import data from "../constants/faq.json";

function Faq() {
  const [activeTab, setActiveTab] = useState("general");

  return (
    <div className="main-content">
      <TopTitle title="Preguntas Frecuentes" />
      <section className="bg-light">
        <div className="container">
          <div className="row align-items-center justify-content-center mb-5">
            <div className="col-xl-12 col-lg-12 col-12">
              <ul
                className="nav nav-pills simple smalls scroll-tab justify-content-center border-0 mb-4"
                id="courseTab"
                role="tablist"
              >
                {data.map((category, index) => (
                  <li className={`nav-item ${index === 0 ? "ms-0" : ""}`} role="presentation" key={category.id}>
                    <button
                      className={`nav-link ${activeTab === category.id ? "active" : ""}`}
                      id={`pills-${category.id}-tab`}
                      data-bs-toggle="pill"
                      data-bs-target={`#pills-${category.id}`}
                      role="tab"
                      type="button"
                      aria-controls={`pills-${category.id}`}
                      aria-selected={activeTab === category.id}
                      onClick={() => setActiveTab(category.id)}
                    >
                      {category.category}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-12 col-lg-12 col-12">
              <div className="tab-content" id="courseTabContent">
                {data.map((category, index) => (
                  <div
                    className={`tab-pane fade ${activeTab === category.id ? "show active" : ""}`}
                    id={`pills-${category.id}`}
                    role="tabpanel"
                    aria-labelledby={`pills-${category.id}-tab`}
                    tabIndex="0"
                    key={category.id}
                  >
                    <div className="row g-4">
                      {[0, 1].map(col => (
                        <div className="col-lg-6 col-md-12" key={col}>
                          <div className="faq-group d-flex flex-column gap-4">
                            {category.questions
                              .filter((_, i) => i % 2 === col)
                              .map((q) => (
                                <FaqItem key={q.title} title={q.title} answer={q.answer} />
                              ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Faq;
